import * as React from "react";
import type { SVGProps } from "react";
const SvgSettingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="setting_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M719.53 193.067a42.752 42.752 0 0 0-37.034-21.547H341.504a42.611 42.611 0 0 0-37.035 21.547L133.973 490.453c-7.68 13.355-7.68 29.782 0 43.094L304.47 830.933c7.638 13.355 21.76 21.547 37.035 21.547h340.992a42.611 42.611 0 0 0 37.035-21.547l170.496-297.386c7.68-13.355 7.68-29.782 0-43.094L719.53 193.067zM230.4 149.973a128.213 128.213 0 0 1 111.104-64.64h340.992c45.867 0 88.235 24.619 111.147 64.64L964.139 447.36a130.048 130.048 0 0 1 0 129.28L793.643 874.027a128.213 128.213 0 0 1-111.147 64.64H341.504a128.213 128.213 0 0 1-111.104-64.64L59.904 576.64a130.048 130.048 0 0 1 0-129.28L230.4 149.973zm195.243 361.174c0-47.574 38.314-86.187 85.546-86.187 47.275 0 85.59 38.613 85.59 86.187 0 47.616-38.315 86.186-85.59 86.186a85.888 85.888 0 0 1-85.546-86.186zm85.546-172.374c-94.506 0-171.136 77.184-171.136 172.374S416.683 683.52 511.19 683.52s171.136-77.184 171.136-172.373-76.629-172.374-171.093-172.374z"
    />
  </svg>
);
export default SvgSettingIcon;
